"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataLayer = void 0;
var react_1 = require("react");
var dataLayerRawPush_1 = require("../helpers/dataLayerRawPush");
/**
 * This hook pushes `dataLayerProps` directly to the window.dataLayer object
 * (it will also remove the existing `em.pageView` events if any exist in `window.dataLayer`, unless specified otherwise).
 * @param dataLayerProps - well, the props
 * @param removePrevious _(optional)_ defaults to `true`. Set to `false` to keep existing (previously pushed) `em.pageView` events in `window.dataLayer`
 * @param enableLogging  _(optional)_ set to `true` to enable console logging
 * @returns
 */
var useDataLayer = function (dataLayerProps, removePrevious, enableLogging) {
    if (removePrevious === void 0) { removePrevious = true; }
    return (0, react_1.useEffect)(function () {
        (0, dataLayerRawPush_1.dataLayerRawPush)(dataLayerProps, removePrevious, enableLogging);
    }, []);
};
exports.useDataLayer = useDataLayer;
//# sourceMappingURL=useDataLayer.js.map